import React, { useCallback } from "react";
import SubGroup from "../../../common/SubGroup";
import ICheckbox from "./ICheckbox";
import SelectionsSimple from "../../../common/SelectionsSimple";

function ParlayTab({ profile }) {
  const handleChanged = useCallback(
    (value, key) => {
      profile[key] = value;
      profile[`Change${key}`] = true;

      console.log(profile);
    },
    [profile]
  );

  const handlePlayerProfileParlayBasicSportsChanged = useCallback(
    (value, key) => {
      profile["PlayerProfileParlayBasicSports"] = {
        ...profile["PlayerProfileParlayBasicSports"],
        [key]: value,
        [`Change${key}`]: true,
      };

      console.log(profile);
    },
    [profile]
  );

  const handlePlayerProfileParlayLimitChanged = useCallback(
    (value, key) => {
      profile["PlayerProfileParlayLimit"] = {
        ...profile["PlayerProfileParlayLimit"],
        [key]: value,
        [`Change${key}`]: true,
      };

      console.log(profile);
    },
    [profile]
  );


  const handlePlayerProfileParlayLimitDetailChanged = useCallback(
    (value, key) => {
      profile["PlayerProfileParlayLimitDetail"] = {
        ...profile["PlayerProfileParlayLimitDetail"],
        [key]: value,
        [`Change${key}`]: true,
      };

      console.log(profile);
    },
    [profile]
  );

  return (
    <div className="grid h-full grid-cols-2 gap-2">
      <div className="flex flex-col h-full min-h-0 col-span-1 gap-2">
        <SubGroup title="Football" className="grid grid-cols-2 gap-2 p-2">
          <div className="flex flex-col">
            <SelectionsSimple
              className="h-full simple-table headerless"
              // GET
              itemKey="NumTeams"
              getUrl={
                "/Profile/PlayerProfileParlayLimit_GetInfo?idProfile=2408"
              }
              getProcess={(data) =>
                data.map((item) => ({
                  ...item,
                  Text: `${item.NumTeams} Teams`,
                }))
              }
              // CHANGE
              onChanged={(NumTeams) => {
                profile["PlayerProfileParlayLimit"] = {
                  ...profile["PlayerProfileParlayLimit"],
                  NumTeams,
                };
                profile["PlayerProfileParlayLimitDetail"] = {
                  ...profile["PlayerProfileParlayLimitDetail"],
                  NumTeams,
                };
              }}
            >
              <TableHeaderColumn
                visible="none"
                isKey={true}
                hidden
                dataField="NumTeams"
              >
                NumTeams
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="Text"
                filter={{ type: "TextFilter" }}
              >
                Text
              </TableHeaderColumn>
            </SelectionsSimple>
          </div>
          <div className="flex flex-col">
            <ICheckbox label="Odds" 
            onChanged={(value) => handlePlayerProfileParlayLimitChanged(value, "Odds")}/>
            <ICheckbox label="Extra Juice" 
            onChanged={(value) => handlePlayerProfileParlayLimitChanged(value, "ExtraJuice")}/>
            <ICheckbox label="Max Risk" 
            onChanged={(value) => handlePlayerProfileParlayLimitChanged(value, "MaxRisk")}/>
            <ICheckbox label="Max Payout" 
            onChanged={(value) => handlePlayerProfileParlayLimitChanged(value, "MaxPayout")}/>
            <ICheckbox label="Open Spots" 
            onChanged={(value) => handlePlayerProfileParlayLimitChanged(value, "MaxOpenSpots")}/>
            <ICheckbox label="Max $+Lines" 
            onChanged={(value) => handlePlayerProfileParlayLimitChanged(value, "MaxMoneyLines")}/>
            <ICheckbox label="Max Totals" 
            onChanged={(value) => handlePlayerProfileParlayLimitChangedf(value, "MaxTotalLines")}/>
          </div>
        </SubGroup>
        <SubGroup title="Max " className="grid grid-cols-2 gap-2 p-2">
          <div className="flex flex-col">
            <SelectionsSimple
              className="h-full simple-table headerless"
              // GET
              itemKey="IdSport"
              getUrl={"/Player/GetSports"}
              // CHANGE
              onChanged={(IdSports) => {
                profile["PlayerProfileParlayBasicSports"] = {
                  ...profile["PlayerProfileParlayBasicSports"],
                  IdSports,
                };
                profile["PlayerProfileParlayLimitDetail"] = {
                  ...profile["PlayerProfileParlayLimitDetail"],
                  IdSports,
                };
              }}
            >
              <TableHeaderColumn
                visible="none"
                isKey={true}
                hidden
                dataField="IdSport"
              >
                IdSport
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="SportName"
                filter={{ type: "TextFilter" }}
              >
                Sports
              </TableHeaderColumn>
            </SelectionsSimple>
          </div>
          <div className="flex flex-col">
            <ICheckbox
              label="Basic Sport"
              onChanged={(value) =>
                handlePlayerProfileParlayBasicSportsChanged(value, "BasicSport")
              }
            />
            <ICheckbox
              label="Max Games"
              onChanged={(value) =>
                handlePlayerProfileParlayLimitDetailChanged(value, "MaxGames")
              }
            />
            <ICheckbox
              label="Max Dogs"
              onChanged={(value) =>
                handlePlayerProfileParlayLimitDetailChanged(value, "MaxDogs")
              }
            />
            <ICheckbox
              label="$-Lines"
              onChanged={(value) =>
                handlePlayerProfileParlayLimitDetailChanged(
                  value,
                  "MaxMoneyLines"
                )
              }
            />
            <ICheckbox
              label="Totals"
              onChanged={(value) =>
                handlePlayerProfileParlayLimitDetailChanged(
                  value,
                  "MaxTotalLines"
                )
              }
            />
          </div>
        </SubGroup>
      </div>
      <div className="flex flex-col h-full min-h-0 col-span-1 gap-2">
        <SubGroup className="!gap-0 p-2">
          <ICheckbox
            label="Max Sides"
            onChanged={(value) => handleChanged(value, "PL_MaxGames")}
          />
          <ICheckbox
            label="Max Odds in Dog Line"
            onChanged={(value) => handleChanged(value, "PL_MaxOdds")}
          />
          <ICheckbox
            label="High Level Buy Points"
            onChanged={(value) => handleChanged(value, "PL_MaxTeamBuyPoints")}
          />
          <ICheckbox
            label="Max Payout"
            onChanged={(value) => handleChanged(value, "PL_MaxPayout")}
          />
          <ICheckbox
            label="Max Buy Points"
            onChanged={(value) => handleChanged(value, "PL_MaxBuyPoints")}
          />
          <ICheckbox
            label="Odds Default"
            onChanged={(value) => handleChanged(value, "PL_OddsDefault")}
          />
          <ICheckbox
            label="Parlay Formula"
            onChanged={(value) => handleChanged(value, "PL_ParlayFormula")}
          />
          <ICheckbox
            label="Tie Loses"
            onChanged={(value) => handleChanged(value, "PL_TieLoses")}
          />
          <ICheckbox
            label="Allow Open Plays"
            onChanged={(value) => handleChanged(value, "PL_AllowOpenPlays")}
          />
          <ICheckbox
            label="Table Odds Range"
            onChanged={(value) => handleChanged(value, "PL_LowerUseDefault")}
          />
          <ICheckbox
            label="Allow Spread and Total in Hockey"
            onChanged={(value) => handleChanged(value, "PL_AllowSpreadTotalHK")}
          />
          <ICheckbox
            label="Allow Spread and Total in Soccer"
            onChanged={(value) =>
              handleChanged(value, "PL_AllowSpreadTotalSOC")
            }
          />
          <ICheckbox
            label="If Money Line then Use True Odds"
            onChanged={(value) => handleChanged(value, "PL_TrueOddsOption")}
          />
          <SubGroup
            title="Max Dogs On"
            className="!gap-0 p-2 mt-2 flex-row justify-between"
          >
            <ICheckbox
              label="Side"
              onChanged={(value) => handleChanged(value, "PL_MaxDogsSide")}
            />
            <ICheckbox
              label="Total"
              onChanged={(value) => handleChanged(value, "PL_MaxDogsTotal")}
            />
            <ICheckbox
              label="Money Line"
              onChanged={(value) => handleChanged(value, "PL_MaxDogsMoney")}
            />
          </SubGroup>
          <SubGroup title="Baseball" className="!gap-0 p-2 mt-2">
            <ICheckbox
              label="Always Action"
              onChanged={(value) => handleChanged(value, "PL_AlwaysAction")}
            />
            <ICheckbox
              label="Allow Run Line and Total"
              onChanged={(value) =>
                handleChanged(value, "PL_AllowRunLineTotal")
              }
            />
          </SubGroup>
        </SubGroup>
      </div>
      <div className="flex flex-col h-full col-span-2 gap-2">
        <SubGroup className="h-full p-2">
          <div className="grid w-full grid-cols-2 gap-2">
            <span>Stop combinations with odds sum higher than</span>
            <div className="flex gap-2">
              <ICheckbox
                label="selection"
                onChanged={(value) => handleChanged(value, "PL_UseMaxSumOdds")}
              />
              <ICheckbox
                label="value"
                onChanged={(value) => handleChanged(value, "PL_MaxSumOdds")}
              />
            </div>
          </div>
        </SubGroup>
      </div>
    </div>
  );
}

export default ParlayTab;
